import { List } from 'antd';
import { Pagination } from 'components/common';
import { useContactHistoriesPaging } from 'hooks/contacts';
import React from 'react';
import { ContactHistoriesItem } from './CustomerLookupContactHistoryItemHistories';

type ContactHistoriesTabProps = {
  contactId: number;
  handleCustomerCodeClick?: (customerCode: string) => void;
};

const ContactHistoriesTab: React.FC<ContactHistoriesTabProps> = ({ contactId, handleCustomerCodeClick }) => {
  const { contactHistories, handleChangePage, pageIndex, pageSize, count, isLoading } = useContactHistoriesPaging({
    contactId
  });

  return (
    <div>
      <div className='flex h-[calc(100vh-242px)] max-h-[calc(100vh-242px)] flex-1 flex-col items-center gap-[22px] overflow-auto pb-5'>
        <List
          className='w-full px-6'
          rowKey={(item) => `contact-history-${item.contactHistoryId}`}
          dataSource={contactHistories}
          renderItem={(item) => (
            <ContactHistoriesItem
              onCustomerClick={handleCustomerCodeClick}
              className={'border-b py-4'}
              key={item.contactHistoryId}
              item={item}
            />
          )}
          loading={isLoading}
        />
        <div className='mt-auto'>
          <Pagination
            count={count}
            loading={isLoading}
            currentPage={pageIndex}
            pageSize={pageSize}
            handleChangePage={(pageIndex: number) => handleChangePage(pageIndex)}
          />
        </div>
      </div>
    </div>
  );
};
export default ContactHistoriesTab;
